export default "__VITE_PUBLIC_ASSET__590b58f5__"